import React from 'react';
import { motion } from 'framer-motion';
import { useLang } from '../context/LanguageContext';

const t = {
  fr: { label: 'Notre Signature', p1: 'Inspired by hospitality,', p2: 'driven by emotion.' },
  en: { label: 'Our Signature', p1: 'Inspired by hospitality,', p2: 'driven by emotion.' },
};

const SignatureSection = () => {
  const { lang } = useLang();
  const tx = t[lang];

  return (
    <section className="relative py-24 md:py-32 bg-[#1a3a52] overflow-hidden">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="max-w-5xl mx-auto text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="mb-8">
            <span className="text-sm uppercase tracking-widest text-[#8b9faa] font-mono">{tx.label}</span>
          </motion.div>
          <motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.2 }} className="space-y-8">
            <h2 className="text-4xl md:text-5xl lg:text-7xl font-brand text-white leading-tight">
              Social media<br /><span className="text-[#d4a574] font-editorial">as an experience.</span>
            </h2>
            <div className="max-w-3xl mx-auto space-y-4 text-xl md:text-2xl text-white/80 font-light font-brand">
              <p>{tx.p1}</p>
              <p>{tx.p2}</p>
            </div>
          </motion.div>
          <motion.div initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }} viewport={{ once: true }} transition={{ duration: 1, delay: 0.6 }} className="w-32 h-px bg-gradient-to-r from-transparent via-[#d4a574] to-transparent mx-auto mt-16" />
        </div>
      </div>
      <div className="absolute top-1/4 left-0 w-96 h-96 bg-[#4a5d6c]/20 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-1/4 right-0 w-96 h-96 bg-[#d4a574]/10 rounded-full blur-3xl pointer-events-none" />
    </section>
  );
};

export default SignatureSection;
